// extracted by mini-css-extract-plugin
module.exports = {"Pixelated":"Image_Pixelated__2pT5A"};